import React, { useState, useEffect } from 'react';
import { Box, CssBaseline, Toolbar, useMediaQuery } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from '../../theme/theme';
import Header from './Header';
import Sidebar from './Sidebar';

const Layout = ({ children }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Close sidebar on mobile when screen size changes
  useEffect(() => {
    if (isMobile) {
      setSidebarOpen(false);
    } else {
      setSidebarOpen(true);
      setMobileMenuOpen(false);
    }
  }, [isMobile]);

  const handleSidebarToggle = () => {
    if (isMobile) {
      setMobileMenuOpen(!mobileMenuOpen);
    } else {
      setSidebarOpen(!sidebarOpen);
    }
  };

  const handleMobileMenuToggle = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const handleSettingsClick = () => {
    // TODO: Implement settings modal/page
    console.log('Settings clicked');
  };

  const handleNotificationsClick = () => {
    // TODO: Implement notifications panel
    console.log('Notifications clicked');
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ display: 'flex', minHeight: '100vh' }}>
        {/* Header */}
        <Header
          onSettingsClick={handleSettingsClick}
          onNotificationsClick={handleNotificationsClick}
          onMobileMenuToggle={handleMobileMenuToggle}
        />

        {/* Sidebar */}
        <Sidebar
          open={isMobile ? mobileMenuOpen : sidebarOpen}
          onToggle={handleSidebarToggle}
          isMobile={isMobile}
        />

        {/* Main Content */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            backgroundColor: 'background.default',
            minHeight: '100vh',
            transition: 'margin-left 0.2s ease-in-out',
            marginLeft: { 
              xs: 0, // No margin on mobile
              md: sidebarOpen ? '280px' : '64px' // Desktop margin based on sidebar state
            }
          }}
        >
          <Toolbar /> {/* Spacer for fixed header */}
          
          {/* Content Area */}
          <Box
            sx={{
              p: { xs: 2, sm: 3 }, // Responsive padding
              minHeight: 'calc(100vh - 64px)', // Subtract header height
              backgroundColor: 'background.default'
            }}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default Layout;
